import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { School } from '../school';

@Component({
  selector: 'app-programmes',
  templateUrl: './programmes.component.html',
  styleUrls: ['./programmes.component.css']
})
export class ProgrammesComponent implements OnInit {

  selectedProgramme!: string;
  schools: School[] = [];
  searchStart = false;
  loading = false;

  constructor(
    private httpService: HttpService
  ) { }

  ngOnInit(): void {
  }

  findSchools(){
    this.searchStart = true;
    this.loading = true;
    this.httpService.getSchoolsByProgrammeName(this.selectedProgramme).subscribe(res => {
      this.schools = res;
      this.loading = false;
    });
  }

}
